<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> {{ pageTitle }} </template>

    <div class="container">
      <div class="row content" v-if="!selectedCanvas">
        <div class="col-12">
          <v-select
            class="vs-big"
            :options="canvasAssignments"
            label="name"
            :clearable="false"
            v-model="selectedAssignment"
            style="width: 300px"
          >
            <template v-slot:selected-option="selectedOption"
              ><div style="height: 30px; overflow: hidden; text-align: left">
                {{ selectedOption.name }}
              </div></template
            >
            <template v-slot:option="option"
              ><div style="overflow: hidden; text-overflow: ellipsis">
                {{ option.name }}
              </div></template
            >
          </v-select>
        </div>
        <div v-for="co in canvasOptions" :key="co.id" class="col-12 col-lg-6">
          <div class="p-3 mt-3 card d-flex flex-row">
            <template v-if="co.canvas">
              <div
                class="flex-grow ml-2 p-2 text-left"
                style="overflow: hidden"
              >
                <div class="si-font text-lg" style="text-overflow: ellipsis">
                  {{ co.team.name }}
                </div>
                <div class="text-extra-muted">
                  {{ fs.medDate(co.canvas.created_at) }}
                </div>
                <div>{{ fs.listNames(co.canvas.students) }}</div>
              </div>
              <div class="pt-2 button-container">
                <a
                  class="btn btn-no-border btn-si-green mb-2"
                  @click="selectCanvas(co.canvas)"
                >
                  View Canvas
                </a>
              </div>
            </template>
            <template v-if="!co.canvas">
              <div
                class="flex-grow ml-2 p-2 text-left"
                style="overflow: hidden"
              >
                <div class="si-font text-lg">
                  {{ co.team.name }}
                </div>
                <div class="text-extra-muted">Not started</div>
                <div>{{ fs.listNames(co.team.students) }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="row content" v-if="selectedCanvas">
        <div
          style="min-height: 750px; overflow: visible; margin-bottom: 100px"
          class="full-width"
        >
          <div class="text-md" style="text-align: left">
            Team Members: {{ fs.listNames(selectedCanvas.students) }}
          </div>
          <CanvasView
            :canEdit="false"
            :canvasData="selectedCanvas"
            :user="user"
            :program="program"
          />
        </div>
      </div>
      <div class="full-width feedback" v-if="selectedCanvas && !contextless">
        <div
          class="btn btn-full-stripe btn-expand si-green text-white text-left"
          :class="{ active: expanded }"
          @click="expanded = !expanded"
        >
          <h1 class="mb-0 si-font">Feedback</h1>
        </div>
        <template v-if="expanded">
          <textarea class="form-control" rows="5" v-model="feedback.response" />
        </template>
      </div>
    </div>

    <template v-slot:footer>
      <div class="col-6 text-right" v-if="user.role != 'JUDGE'">
        <button
          v-if="selectedCanvas"
          class="btn btn-si-secondary"
          @click="goBack"
        >
          Back
        </button>
        <a
          v-if="!selectedCanvas && !contextless"
          class="btn btn-si-secondary"
          href="#/canvas"
        >
          Back
        </a>
        <a
          v-if="!selectedCanvas && contextless"
          class="btn btn-si-secondary"
          href="#/score?view=teacher"
        >
          Back
        </a>
        <a v-if="selectedCanvas && !contextless" class="btn btn-si-secondary ml-3" @click="submit" :disabled="submitting">
          Submit
        </a>
      </div>
    </template>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import CanvasView from "@/components/CanvasView";

import SectionService from "@/services/SectionService";
import CanvasService from "@/services/CanvasService";
import ProgramService from "@/services/ProgramService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import _ from "lodash";

export default {
  name: "Canvases",

  props: ["user"],

  components: { MainPage, CanvasView },

  data() {
    var contextless = false;
    if (this.$route.params.sectionID && this.user.role == "ADMIN") {
      contextless = true;
    }

    return {
      fs: fs,

      context: null,
      teams: null,
      canvasOptions: null,
      canvasAssignments: [],
      selectedAssignment: null,
      selectedCanvas: null,
      canvases: null,
      feedbacks: null,
      submitting: false,

      program: null,

      expanded: false,
      feedback: null,

      contextless: contextless,
      sectionID: this.$route.params.sectionID,
    };
  },

  watch: {
    selectedAssignment() {
      this.constructCanvasOptions();
    },
  },

  computed: {
    pageTitle() {
      if (this.selectedCanvas) {
        return this.selectedAssignment.name;
      } else {
        return "CANVASES";
      }
    },
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      var calls = {}
      if (this.contextless) {
        calls = {
        context: SectionService.getSectionPrefilled(this.sectionID),
        canvases: CanvasService.getSectionCanvasesPrefilled(this.sectionID),
        feedback: CanvasService.getSectionCanvasFeedbacks(this.sectionID),
        program: ProgramService.getSectionProgram(this.sectionID),
       }
      } else {
        calls = {
        context: SectionService.getContextPrefilled(),
        canvases: CanvasService.getContextCanvasesPrefilled(),
        feedback: CanvasService.getContextCanvasFeedbacks(),
        program: ProgramService.getContextProgram(),
       }
      }
      BB.props(calls)
        .then((r) => {
          this.loading = false;
          this.context = r.context.data;
          this.teams = this.context.teams;
          this.teams = _.sortBy(this.teams, "name");
          this.canvases = r.canvases.data;
          this.canvasAssignments = this.context.canvases;
          this.program = r.program.data;
          this.feedbacks = r.feedback.data;

          if (this.user.role == "PARTNER") {
            this.canvasAssignments = _.filter(this.context.canvases, {
              show_partner: true,
            });
          }
          if (this.canvasAssignments.length < this.context.canvases.length) {
            Notie.error("Some canvases have been hidden by teacher")
          }

          this.canvasAssignments = _.sortBy(this.canvasAssignments, "due_date").reverse();

          if (this.canvasAssignments && this.canvasAssignments.length > 0) {
            this.selectedAssignment = this.canvasAssignments[0];
          }

					_.each(this.teams, team => {
						team.students = _.filter(team.students, s => {
							return this.context.student_ids.includes(s.id)
						})
					});
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          Notie.error("Failed to load canvases", e);
        });
    },

    constructCanvasOptions() {
      if (!this.selectedAssignment) {
        console.log("NO ASSIGNMENT");
        return;
      }

      let options = [];
      _.each(this.teams, (team) => {
        console.log("process team", team.name);
        let co = {};
        co.team = team;
        co.canvas = _.find(this.canvases, {
          assignment_id: this.selectedAssignment.id,
          team_id: team.id,
        });

        if (
          this.user.role != "JUDGE" ||
          team.judge_ids.includes(this.user.id)
        ) {
          options.push(co);
        }
      });

      console.log("RETURN OPTIONS", options);
      this.canvasOptions = options;
    },

    selectCanvas(canvas) {
      if (this.user.role == "PARTNER" && !this.selectedAssignment.show_partner) {
        return
      }
      console.log(this.feedbacks);
      this.selectedCanvas = canvas;

      //get feedback
      this.feedback = _.find(this.feedbacks, {
        assignment_id: this.selectedAssignment.id,
        team_id: canvas.team_id,
        user_id: this.user.id,
      });
      if (!this.feedback) {
        this.feedback = {
          assignment_id: this.selectedAssignment.id,
          team_id: canvas.team_id,
          user_id: this.user.id,
          response: "",
        };
      }
    },
    goBack() {
      this.$nextTick(() => {
        this.selectedCanvas = null;
        this.loadData();
      });
    },
    submit() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      var team = _.find(this.teams, { id: this.selectedCanvas.team_id });
      console.log(team);
      CanvasService.submitFeedback(this.feedback)
        .then(() => {
          Notie.success("Feedback submitted");
          this.selectedCanvas = null;
          this.loadData();
          this.submitting = false;
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to submit feedback", e);
          this.submitting = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.button-container {
  display: flex;
  flex-direction: column;
  width: 170px;
}
.btn-no-border {
  padding: 5px;
}
.full-width {
  max-width: 90vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -45vw;
  margin-right: -45vw;
}
.feedback {
  width: 100%;
  margin-bottom: 100px;
  transition: opacity 0.5s;
}
</style>
